import Chunk from './Chunk';

const Chunks = ({chunks, loaded, onLoad}) => (
    <tr>
        {chunks.map(chunk => (
            <Chunk
                {...chunk}
                loaded={loaded[chunk.index]}
                onLoad={onLoad}
            />
        ))}
    </tr>
);

export default Chunks;
